// Setup carousel elements
import { Swiper, Navigation, EffectFade } from 'swiper';

Swiper.use([Navigation, EffectFade]);

function init() {
  function changeColour(swiper) {
    const { colour } = swiper.slides[swiper.activeIndex].dataset;

    if (colour) {
      const changesColour = document.querySelectorAll('.js-changes-colour');

      changesColour.forEach(section => {
        const previousColour = section.dataset.currentColour;

        if (previousColour) {
          section.classList.remove(`bg-${previousColour}`);
        }

        section.classList.add(`bg-${colour}`);
        section.setAttribute('data-current-colour', colour);

        const buttons = section.querySelectorAll('a.btn:not(.no-colour-change)');

        if (buttons.length) {
          buttons.forEach(btn => {
            const btnPrevColour = btn.dataset.currentColour;

            if (btnPrevColour) {
              btn.classList.remove(`hover_text-${btnPrevColour}`);
            }

            btn.classList.add(`hover_text-${colour}`);
            btn.setAttribute('data-current-colour', colour);
          });
        }
      });
    }
  }

  function addArrows(swiper) {
    const nextTrigger = swiper.navigation.nextEl.querySelectorAll('img');
    const prevTrigger = swiper.navigation.prevEl.querySelectorAll('img');

    if (swiper.isEnd) {
      nextTrigger.forEach(trigger => {
        trigger.classList.add('hide');
        trigger.classList.remove('show');
      });
      prevTrigger.forEach(trigger => {
        trigger.classList.remove('hide');
        trigger.classList.add('show');
      });
    }

    if (swiper.isBeginning) {
      nextTrigger.forEach(trigger => {
        trigger.classList.add('show');
        trigger.classList.remove('hide');
      });
      prevTrigger.forEach(trigger => {
        trigger.classList.remove('show');
        trigger.classList.add('hide');
      });
    }

    if (!swiper.isBeginning && !swiper.isEnd) {
      nextTrigger.forEach(trigger => {
        trigger.classList.add('show');
        trigger.classList.remove('hide');
      });
      prevTrigger.forEach(trigger => {
        trigger.classList.remove('hide');
        trigger.classList.add('show');
      });
    }
  }

  window.addEventListener('curtain', () => {
    const { headerType } = document.body.dataset;
    const swiperTemplates = document.querySelector(
      `.header-section-${headerType} .swiper-templates`,
    );
    let slidesPerView;
    let initialSlide;
    let loop;
    let templateBreakpoints;
    let speed;

    speed = 800;

    templateBreakpoints = {
      1080: {
        noSwiping: true,
      },
    };

    if (swiperTemplates) {
      if (headerType === '2') {
        if (window.innerWidth < 640) {
          slidesPerView = 1;
        } else if (window.innerWidth <= 1024) {
          slidesPerView = 1.8;
        } else {
          slidesPerView = 3.2;
        }

        initialSlide = 1;
      } else if (swiperTemplates.classList.contains('header-type-3')) {
        if (swiperTemplates.classList.contains('header-type-5')) {
          // Type 5
          // if (window.innerWidth < 640) {
          //     slidesPerView = 1;
          // } else if (window.innerWidth < 1024) {
          //     slidesPerView = 1.8;
          // } else {
          //     slidesPerView = "auto";
          // }
          slidesPerView = 'auto';

          initialSlide = 0;
        } else {
          // Type 3
          if (window.innerWidth < 640) {
            slidesPerView = 1;
          } else if (window.innerWidth < 1024) {
            slidesPerView = 1.8;
          } else {
            slidesPerView = 2;
          }

          initialSlide = 0;
        }
      } else if (headerType === '4') {
        // if (window.innerWidth < 640) {
        //     slidesPerView = 1.2;
        // } else if (window.innerWidth <= 1280) {
        //     slidesPerView = 3;
        // } else {
        //     slidesPerView = 4.2;
        // }
        slidesPerView = 1.2;
        templateBreakpoints = {
          640: {
            slidesPerView: 3.3,
          },

          1280: {
            slidesPerView: 3.5,
            noSwiping: true,
          },
        };

        speed = 400;
        loop = true;
        initialSlide = 1;
      }
    }

    let templateSelector = '';
    if (headerType === '1') {
      templateSelector = '.template-slider-for-header-one .swiper-templates';
      if (window.innerWidth < 640) {
        slidesPerView = 1;
      } else {
        slidesPerView = 1.8;
      }

      loop = false;

      initialSlide = 0;
    } else {
      templateSelector = `.header-section-${headerType} .swiper-templates`;
    }

    // eslint-disable-next-line no-new
    new Swiper(templateSelector, {
      loop,
      speed,
      slidesPerView,
      autoHeight: false,
      centeredSlides: true,
      initialSlide,
      preventInteractionOnTransition: true,
      noSwiping: false,

      breakpoints: {
        ...templateBreakpoints,
      },

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      on: {
        slideChange(swiper) {
          setTimeout(() => {
            addArrows(swiper);
            changeColour(swiper);
          }, 1);
        },
        init(swiper) {
          changeColour(swiper);
        },
      },
    });

    // Swiper found on templates page
    if (window.innerWidth < 640) {
      // eslint-disable-next-line no-new
      new Swiper('.swiper-templates-page', {
        loop: true,
        speed: 800,
        slidesPerView: 1.35,
        autoHeight: true,
        centeredSlides: true,
        initialSlide: -3,
        preventInteractionOnTransition: false,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

      // Add click state
      document.querySelectorAll('.swiper-templates-page .swiper-slide').forEach(template => {
        const hoverCard = template.querySelector('.template-card-hover');
        hoverCard.addEventListener('click', () => {
          hoverCard.classList.toggle('show');
        });
      });
    }

    // eslint-disable-next-line no-new
    new Swiper('.swiper-landing-pages', {
      loop: false,
      speed: 400,
      slidesPerView: 'auto',
      autoHeight: true,
      centeredSlides: true,
      preventInteractionOnTransition: true,

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      on: {
        slideChange(swiper) {
          setTimeout(() => {
            addArrows(swiper);
          }, 1);
        },
      },
    });

    // eslint-disable-next-line no-new
    new Swiper('.swiper-forms', {
      loop: false,
      speed: 400,
      slidesPerView: 'auto',
      autoHeight: false,
      centeredSlides: true,
      preventInteractionOnTransition: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      on: {
        slideChange(swiper) {
          setTimeout(() => {
            addArrows(swiper);
          }, 1);
        },
      },
    });
  });
}

(() => {
  init();
})();
